import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `
   <div>
     <p><strong>Description</strong></p>
     <p>This alert is generated to keep associates safe by helping avoid packages overflowing from the Pick to Buffer Racks onto the ground. This alert generates if/when a specific Stow Aisle’s at Station Work in Progress (WIP) exceeds 45 Minutes’ worth of WIP as seen in Station Command Center’s (SCC’s) Stow Heat Map. This alert will not generate during the planned break times within SCC’s Settings Tab. This alert is expected to be completed ASAP by stowing the At Risk Aisle down below 45 minutes of WIP. If the At Risk Aisle is not stowed down below 45 minutes of WIP, the alert will stay active for up to 2 hours before expiring and generating another Alert for the same At Risk Aisle.</p>
     <p><strong>Resolution Steps</strong></p>
     <ol>
        <li>Confirm a Stow Associate has moved to the At-Risk Aisle that has +45 Minutes of WIP</li>
        <li>Coach the Stow Associate responsible for the At Risk on the importance of checking their device for highlighted Red At Risk Aisles which indicate the highest priority and needing immediate attention</li>
        <li>
           Coach the Stow Associate on Smart Stow Best Practices like:
           <ol style="list-style-type:lower-alpha">
              <li>Stow a Pick to Buffer Rack down to roughly 25%, then move to the next Aisle. Do Not Stow a Pick to Buffer Rack down to 0 Packages before moving to the Next Aisle.</li>
              <li>Stow the Totes first</li>
              <li>Use the Smart Stow Cart</li>
              <li>Use a Finger Scanner</li>
           </ol>
        </li>
     </ol>
     <p><strong>Supplemental Links</strong></p>
     <ol>
        <li><span class="wikiinternallink"><a href="https://start.wwops.amazon.dev/stableLink/lms/HEADER-h2-269887-26?version=49">START’s Smart Stow – Stow SOP</a></span></li>
        <li><span class="wikiinternallink"><a href="https://apollo-audit.corp.amazon.com/audits/new?audit_type_id=11027">Apollo’s Smart Stow Adherence &amp; Standardization Audit</a></span></li>
     </ol>
  </div>
   `
);


// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Aisles_At_Risk_SCC.jsx